import { SIES } from '../endpoints';
import request from '../request';

export function getSIESConfig() {
  return request<{ enabled: boolean }>(SIES.CONFIG);
}
